import React, { useCallback } from 'react';
import { ButtonData_Type } from 'ricos-schema';
import { normalizeHref, getRelValue } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { ROOT } from '../dataHooks.js';
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from '../types.js';

var css_248z = ".NhFo1{box-sizing:border-box;color:var(--ricos-background-color,#fff);display:inline-block;position:relative;text-decoration:none}[dir] .NhFo1{background-color:var(--ricos-action-color,#116dff);border-color:var(--ricos-action-color,#116dff);border-style:none;border-width:0;cursor:pointer;margin:5px;padding:12px}._2e0qN{font-family:var(--ricos-custom-p-font-family);font-size:14px;max-width:716px;min-width:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir] ._2e0qN{text-align:center}.brT5w{width:auto}";
var styles = {"button_container":"NhFo1","button_text":"_2e0qN","button_size_content":"brT5w"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ButtonViewer = ({ onClick, helpers, settings = {}, buttonData }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  const isActionButton = buttonData.type === ButtonData_Type.ACTION;
  const onClickHandler = useCallback(() => {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "");
    onClick == null ? void 0 : onClick();
  }, [helpers == null ? void 0 : helpers.onViewerAction]);
  const Component = isActionButton ? "div" : "a";
  const style = {
    color: (_d = (_b = (_a = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _a.colors) == null ? void 0 : _b.text) != null ? _d : (_c = settings.colors) == null ? void 0 : _c.color1,
    background: (_h = (_f = (_e = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _e.colors) == null ? void 0 : _f.background) != null ? _h : (_g = settings.colors) == null ? void 0 : _g.color8,
    borderRadius: (_j = (_i = buttonData.styles) == null ? void 0 : _i.border) == null ? void 0 : _j.radius,
    width: `min(100%, ${(_l = (_k = buttonData.containerData) == null ? void 0 : _k.width) == null ? void 0 : _l.custom}px)`,
    border: `${((_n = (_m = buttonData.styles) == null ? void 0 : _m.border) == null ? void 0 : _n.width) || 0}px solid ${(_r = (_p = (_o = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _o.colors) == null ? void 0 : _p.border) != null ? _r : (_q = settings.colors) == null ? void 0 : _q.color8}`
  };
  return /* @__PURE__ */ React.createElement(
    Component,
    __spreadValues({
      className: styles.button_container,
      style,
      "data-hook": ROOT,
      onClick: onClickHandler,
      tabIndex: 0,
      role: "button",
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onClickHandler();
        }
      }
    }, !isActionButton && {
      href: ((_s = buttonData.link) == null ? void 0 : _s.url) && normalizeHref(buttonData.link.url),
      target: ((_t = buttonData.link) == null ? void 0 : _t.target) && `_${buttonData.link.target.toLowerCase()}`,
      rel: ((_v = (_u = buttonData.link) == null ? void 0 : _u.rel) == null ? void 0 : _v.nofollow) ? getRelValue("nofollow") : void 0
    }),
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text)
  );
};

export { ButtonViewer };
//# sourceMappingURL=button-viewer.js.map
